export default {
    // SET_CATEGORIES(state,categories){  state.Categories = categories; },

}